import i18n from 'i18next';
import languageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import locales from 'src/locales';
import { PRIMARY_LANG } from 'src/packages/language/consts';

import { widgetNamespacesBackend } from './widgetNamespaces';

const detectorOptions = {
  caches: ['localStorage', 'cookie'],
  lookupCookie: 'i18next',
  lookupLocalStorage: 'i18nextLng',
  lookupQuerystring: 'lng',
  order: ['localStorage', 'cookie', 'querystring', 'path'],
};

const i18nInstance = i18n.createInstance();

i18nInstance
  .use(widgetNamespacesBackend)
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    detection: detectorOptions,
    defaultNS: 'common',
    fallbackLng: PRIMARY_LANG || 'en',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: true,
    },
    partialBundledLanguages: true,
    resources: locales,
  });

export default i18nInstance;
